/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcProperties { 
    last_updated?: Date;
    vmc_md5_hash?: string;
    /**
     * Mapped VMC Org ID.
     */
    vmc_org_id?: string;
    vmc_org_type?: string;
    /**
     * vmc properties
     */
    vmc_properties?: object;
}

